import { color as semanticColor } from "../tokens/semantic";
import { MuiButton, MuiIconButton, MuiCard, MuiCardHeader, MuiCardContent, MuiCardActions, MuiLink, MuiFab, MuiListItemButton, MuiChip, MuiStepIcon, MuiStepLabel, MuiStepConnector, MuiStep, MuiStepper, MuiRadio, MuiCheckbox, MuiSwitch } from "./components-styles";

export const components = {
    // Disable ripple globally for all components using ButtonBase (includes radio buttons, checkboxes, listbuttons, etc.)
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true,
        },
    },

    // Global baseline styles
    MuiCssBaseline: {
        styleOverrides: {
            body: {
                backgroundColor: semanticColor.bg.primary,
            },
        },
    },

    // Typography
    MuiTypography: {
        defaultProps: {
            variantMapping: {
                body: 'p',
                bodySmall: 'p',
            },
        },
        variants: [
            {
                props: { variant: 'body' },
                style: ({ theme }) => ({
                    ...theme.typography.body1,
                }),
            },
            {
                props: { variant: 'bodySmall' },
                style: ({ theme }) => ({
                    ...theme.typography.body2,
                }),
            },
        ],
    },

    // Buttons
    MuiButton,

    // Icon Buttons
    MuiIconButton,

    // Cards
    MuiCard,
    MuiCardHeader,
    MuiCardContent,
    MuiCardActions,

    //Link
    MuiLink,

    //Floating action button
    MuiFab,

    // List item button
    MuiListItemButton,

    // Chip (selection / filter chips)
    MuiChip,

    // Stepper
    MuiStepper,
    MuiStepIcon,
    MuiStepLabel,
    MuiStepConnector,
    MuiStep,

    // Radio
    MuiRadio,

    // Checkbox
    MuiCheckbox,

    // Switch
    MuiSwitch,
};

export default components;